import React from "react"
import PropTypes from "prop-types"
import {
  Avatar,
  Box,
  Chip,
  styled,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core"
import formatter from "@/services/formatter"
import {
  LayersOutlined,
  SquareFootOutlined,
  StopOutlined,
} from "@material-ui/icons"

const numberFormat = Intl.NumberFormat("pt-br", { minimumFractionDigits: 2 })

const StyledButton = styled("button")(({ theme }) => ({
  border: "0.5px solid",
  borderColor: theme.palette.divider,
  backgroundColor: "transparent",
  borderRadius: 4,

  padding: "1rem",

  transition: theme.transitions.create(["box-shadow"], {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest,
  }),

  "&:hover": {
    boxShadow: theme.shadows[3],
  },

  ["&[data-selected=true]"]: {
    borderWidth: 2,
    boxShadow: theme.shadows[2],
    borderColor: theme.palette.primary.main,
  },
}))

const CustomTooltip = withStyles((theme) => ({
  tooltip: (props) => {
    const columnsCount = props["data-columns"]

    return {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      boxShadow: theme.shadows[2],

      "& li:nth-child(odd)": {
        backgroundColor: theme.palette.primary.light,
      },

      [theme.breakpoints.up("sm")]: {
        maxWidth: "none",
        width: columnsCount > 1 ? 800 : 400,
      },
    }
  },
  arrow: {
    color: theme.palette.primary.main,
  },
}))(Tooltip)

// -----------------------------------------------------------------------

function PalletBatchListItem(props) {
  return (
    <Box
      px={1}
      py={0.5}
      display="flex"
      flexDirection="column"
      component="li"
      borderRadius={3}
    >
      <Typography variant="body1">
        {props.pallet_tag?.product_description.dsc_abreviado}
      </Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="caption" style={{ fontWeight: "bold" }}>
          {props.pallet_tag?.cod_produto} -{" "}
          {props.pallet_tag?.product_description.dsc_item}
        </Typography>

        <Typography>{props.pallet_tag?.etiq_qtde_cx} caixa(s)</Typography>

        {/* <Typography variant="body2" style={{ fontWeight: "bold" }}>
          {numberFormat.format(Number(props.pallet_tag.etiq_qtde))} m² - Ton:{" "}
          {props.pallet_tag.etiq_tonalidade} - Bit: {props.pallet_tag.etiq_bitola}
        </Typography> */}
      </Box>
    </Box>
  )
}

// -----------------------------------------------------------------------

export function PalletBatch({ selected, data, ...props }) {
  const length = data.items.length

  function getAmountColumns() {
    if (length <= 4) return 1
    if (length <= 8) return 2
    if (length <= 16) return 3
    return 4
  }

  const columnsAmount = getAmountColumns()

  return (
    <CustomTooltip
      arrow
      data-columns={columnsAmount}
      placement="top"
      PopperProps={{
        style: {
          zIndex: 100000,
        },
      }}
      title={
        <Box
          padding={1}
          component="ul"
          display="grid"
          gridTemplateColumns={`repeat(${columnsAmount}, 1fr)`}
          gridGap="0.45rem"
        >
          {data.items.map((item, index) => {
            return <PalletBatchListItem key={index} {...item} />
          })}
        </Box>
      }
    >
      <StyledButton data-selected={selected} type="button" {...props}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gridGap="0.5rem"
        >
          <Typography variant="body1" style={{ fontSize: 18, fontWeight: 600 }}>
            {data.cod_etiqueta}
          </Typography>

          <Typography variant="caption" color="textSecondary">
            {formatter(data.brd_data).toSimpleDate()}
          </Typography>
        </Box>

        <Box display="flex" gridGap="0.5rem" mt={1}>
          <Chip
            size="medium"
            color="default"
            variant="outlined"
            label={numberFormat.format(Number(data.etiq_qtde)) + " m²"}
            avatar={
              <Avatar>
                <SquareFootOutlined fontSize="small" />
              </Avatar>
            }
          />
          <Chip
            size="medium"
            color="default"
            variant="outlined"
            label={data.etiq_qtde_cx}
            avatar={
              <Avatar>
                <StopOutlined fontSize="small" />
              </Avatar>
            }
          />
          <Chip
            size="medium"
            color="default"
            variant="outlined"
            label={data.items.length}
            avatar={
              <Avatar>
                <LayersOutlined fontSize="small" />
              </Avatar>
            }
          />
        </Box>
      </StyledButton>
    </CustomTooltip>
  )
}

PalletBatch.propTypes = {
  data: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
}
